import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CurrencyProvider } from "./lib/currency";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";
import { Header } from "./components/Header";
import { TickerBar } from "./components/TickerBar";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import AssetDetail from "./pages/AssetDetail";
import Macro from "./pages/Macro";
import Watchlist from "./pages/Watchlist";
import OpenTrades from "./pages/OpenTrades";
import ClosedPositions from "./pages/ClosedPositions";
import Portfolio from "./pages/Portfolio";
import Budget from "./pages/Budget";
import Opportunities from "./pages/Opportunities";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import AuthCallback from "./pages/AuthCallback";

const TOAST_STYLE = {
    background: "#111114",
    border: "1px solid #2a2a30",
    color: "#e6e6e6",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: 12,
};
const TOAST_OPTIONS = { style: TOAST_STYLE };

// Synchronous check at render time so we never miss the session_id
function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
                path="/*"
                element={
                    <ProtectedRoute>
                        <ShellWithHeader />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}

function ShellWithHeader() {
    return (
        <>
            <Header />
            <TickerBar />
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/asset/:symbol" element={<AssetDetail />} />
                <Route path="/macro" element={<Macro />} />
                <Route path="/opportunities" element={<Opportunities />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/budget" element={<Budget />} />
                <Route path="/trading" element={<OpenTrades />} />
                <Route path="/closed-positions" element={<ClosedPositions />} />
                <Route path="/watchlist" element={<Watchlist />} />
                <Route path="/profile" element={<Profile />} />
            </Routes>
        </>
    );
}

function App() {
    return (
        <div className="App min-h-screen">
            <I18nProvider>
                <CurrencyProvider>
                    <BrowserRouter>
                        <AuthProvider>
                            <AppRouter />
                            <Toaster position="bottom-right" theme="dark" toastOptions={TOAST_OPTIONS} />
                        </AuthProvider>
                    </BrowserRouter>
                </CurrencyProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
